<template>
  <div
    id="wallet-transactions"
    class="empty-placeholder dash-card bg-white"
    v-if="loading && !errorLoading"
  >
    <b-spinner></b-spinner>
  </div>
  <b-button variant="primary" @click="getTransactions" v-else-if="errorLoading"
    >Network Error, Please Retry</b-button
  >
  <div
    v-else-if="transactions.length < 1"
    class="empty-placeholder dash-card bg-white"
  >
    You have no transactions yet
  </div>
  <b-row v-else>
    <b-col cols="12">
      <div class="list dash-card p-3 w-100 bg-white mb-2">
        <b-row>
          <b-col style="font-weight:bold">Amount</b-col>
          <b-col style="font-weight:bold">Date</b-col>
        </b-row>
      </div>
      <div
        @click="showDetails(transaction)"
        class="list dash-card p-3 w-100 bg-white mb-2"
        v-for="transaction in transactions"
        :key="transaction.id"
        style="cursor:pointer"
        :class="transaction.transactiontype"
      >
        <b-row>
          <b-col>
            {{ formatMoney(transaction.amount) }}
          </b-col>
          <b-col>
            {{
              LuxonDateTime.fromJSDate(
                new Date(transaction.createdat)
              ).toFormat("LLL dd yyyy")
            }}
          </b-col>
        </b-row>
      </div>
    </b-col>
    <b-col cols="12">
      <b-pagination
        v-model="page"
        :total-rows="total"
        :per-page="perPage"
        align="right"
        @change="pageChange"
      ></b-pagination>
    </b-col>
    <TransactionDetailModal :transaction="activeTransaction" />
  </b-row>
</template>

<script>
import { DateTime as LuxonDateTime } from "luxon";
import { formatMoney } from "@/utils/helpers";
import { TransactionService } from "@/services";
import TransactionDetailModal from "./TransactionDetailModal";
export default {
  name: "wallet-transactions",
  data() {
    return {
      transactions: [],
      activeTransaction: {},
      perPage: 5,
      page: 1,
      lastPage: 1,
      total: 0,
      loading: false,
      errorLoading: false,
      LuxonDateTime: LuxonDateTime
    };
  },
  components: {
    TransactionDetailModal
  },
  async created() {
    await this.getTransactions();
  },
  methods: {
    formatMoney,
    showDetails(data) {
      this.activeTransaction = data;
      this.$bvModal.show("wallet-transaction-modal");
    },
    async getTransactions(curPage = 1) {
      this.errorLoading = false;
      this.loading = true;
      try {
        const {
          data: { data: transactions, lastPage, perPage, total }
        } = await TransactionService.getWalletTransactions(curPage);
        this.transactions = transactions;
        this.perPage = perPage;
        this.lastPage = lastPage;
        this.total = total;
        this.loading = false;
      } catch (err) {
        this.errorLoading = true;
      }
    },
    async pageChange(page) {
      if (page == this.page) return;
      this.loading = true;
      await this.getTransactions(page);
      this.page = page;
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}

#wallet-page {
  .credit {
    background-color: #ceface !important;
  }

  .debit {
    background-color: #ffdbd8 !important;
  }
}
</style>
